require.register("modules/m0x/a04/page-47-co/page-47", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_47co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_47co;

  
});

